import {ChartEntry, TJDayData, UserBinLiquidityEntry} from "../types";
import { chainTokenByAddress, chainTokens } from "~/config/constants/tokens";


export const mapDayData = (dayData: TJDayData): ChartEntry => ({
    date: dayData.date,
    volumeUSD: parseFloat(dayData.volumeUSD),
    liquidityUSD: parseFloat(dayData.totalValueLockedUSD),
  })


export const mapLBPair = (lbPair: any) : {id?: string, tokenXPrice?: number, tokenYPrice?: number} => {
    return {
        id: lbPair.id,
        tokenXPrice: parseFloat(lbPair?.tokenXPrice),
        tokenYPrice: parseFloat(lbPair?.tokenYPrice),
  }
}


export const sortBins = (bins?: UserBinLiquidityEntry[]) : UserBinLiquidityEntry[] => {
  return bins?.sort( (bin1, bin2) => {
    if (bin1.binId > bin2.binId) {
      return 1
    }
    if (bin1.binId < bin2.binId) {
      return -1
    }
    return 0
  })
}

export const mapTokenSymbols = (poolData)  => {


  const mappedTokenXSymbol = chainTokenByAddress(poolData?.chainId, poolData.tokenX?.address)?.symbol ?? poolData?.tokenX.symbol
  const mappedTokenYSymbol = chainTokenByAddress(poolData?.chainId, poolData.tokenY?.address)?.symbol ?? poolData?.tokenY.symbol

  // const mappedTokenXSymbol = chainTokens[poolData?.tokenX?.symbol?.toLowerCase()]?.symbol ?? poolData?.tokenX.symbol
  // const mappedTokenYSymbol = chainTokens[poolData?.tokenY?.symbol?.toLowerCase()]?.symbol ?? poolData?.tokenY.symbol

  return {
    ...poolData,
    tokenX: {
      ...poolData.tokenX,
      symbol: mappedTokenXSymbol
    },
    tokenY: {
      ...poolData.tokenY,
      symbol: mappedTokenYSymbol,
    }
  }
}
